/* prettier-ignore */
/**
 * NOTE:
 *
 * This file is automatically generated by Traduki 2.0.
 * DO NOT CHANGE IT BY HAND or your changes will be lost.
 */
//Portuguese (Brazil)
export default {
  'team-central.give-jira-kudos.created.description.flag': 'A equipe de Experiência no local de trabalho vai atender à solicitação de presente. ✨',
  'team-central.give-jira-kudos.created.title.flag': 'Elogio criado',
  'team-central.give-jira-kudos.creation.failed.description.flag': 'Não foi possível criar os elogios nem enviar o presente. Crie um ticket separado em <a>go/kudos</a>.',
  'team-central.give-jira-kudos.creation.failed.title.flag': 'Algo deu errado',
  'team-central.give-kudos.button': 'Envie elogios',
  'team-central.give-kudos.close-button.label': 'Fechar gaveta',
  'team-central.give-kudos.confirm-close.title': 'Confirmar Fechar',
  'team-central.give-kudos.created.description.flag': 'O elogio foi enviado. <a>Ver elogios</a>',
  'team-central.give-kudos.created.title.flag': 'Elogio criado',
  'team-central.give-kudos.creation.failed.description.flag': 'Não foi possível criar os elogios.',
  'team-central.give-kudos.creation.failed.title.flag': 'Algo deu errado',
  'team-central.give-kudos.error-icon.label': 'Erro',
  'team-central.give-kudos.success-icon.label': 'Sucesso',
  'team-central.give-kudos.unsaved.warning': 'As alterações que você fez não vão ser salvas.',
  'team-central.give-kudos.unsaved.warning.cancel': 'Cancelar',
  'team-central.give-kudos.unsaved.warning.close': 'Fechar'
};